<template>
  <div class="mb-3 p-3 border rounded">
    <div class="d-flex">
      <div class="d-none d-sm-inline-block">
        <a v-if="link!==''" :href="link" target="_blank">
          <div :data-mimetype="mimeTypeLabel" class="img border-0"></div>
        </a>
        <router-link v-else :to="to" target="_blank">
          <div :data-mimetype="mimeTypeLabel" class="img border-0"></div>
        </router-link>
      </div>
      <div class="container">
        <d-row>
          <d-col cols="12" class="text-muted">
            <h5 class="mb-1 font-weight-bold pr-2">
              <a v-if="link!==''" class="text-dark text-decoration-none" :href="link" target="_blank">{{ title }} <i class="material-icons ml-1 text-primary">arrow_forward_ios</i></a>
              <router-link v-else class="text-dark text-decoration-none" :to="to" target="_blank">{{ title }} <i class="material-icons ml-1">play_circle_filled</i></router-link>
            </h5>
          </d-col>
          <d-col cols="12" class="text-muted mt-1" v-if="rowBody !== ''" v-html=" rowBody.length > 120 ? rowBody.substring(0,120) + '...' : rowBody"></d-col>
          <d-col cols="12" class="mt-4">
            <d-row>
              <d-col :sm="details.length > 2 ? 4 : 6" v-for="detail in details" :key="detail.label" class="mb-2 mb-lg-1">
                <div class="font-weight-bold mb-1 text-muted">{{detail.label}}</div>
                <div class="text-dark">{{detail.value}}</div>
                <div v-if="detail.subAttribute" class="small" :class="detail.subAttribute.class">({{detail.subAttribute.value}})</div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </div>
    </div>
  </div>

  <!-- <div class="blog-comments__item d-flex p-3">
    <div class="blog-comments__avatar mr-3">
      <img class="img" :data-mimetype="mimeTypeLabel" />
    </div>
    <d-container class="dr-example-container">
      <d-row class="blog-comments__content">
        <d-col sm="12" class="blog-comments__meta text-muted">
          <a v-if="link!==''" class="text-secondary" :href="link" style="word-break: break-word;">{{ title }}</a>
          <router-link v-else class="text-fiord-blue" :to="to">{{ title }}</router-link>
        </d-col>
        <d-col sm="12" class="m-0 mb-1 text-reagent-gray small" v-if="rowBody !== ''" v-html=" rowBody.length > 120 ? rowBody.substring(0,120) + '...' : rowBody"></d-col>
        <d-col :md="details.length > 2 ? 4 : 6" v-for="detail in details" :key="detail.label" class="small mb-2">
          <div class="text-light">{{detail.label}}</div>
          <div>{{detail.value}}</div>
        </d-col>
      </d-row>
    </d-container>
  </div> -->

</template>
<script>
export default {
  name: 'HitsList',
  props: {

    link: {
      type: String,
      default: '',
    },
    to: {
      type: Object,
      default() {
        return {};
      },
    },

    letterImg: {
      type: String,
      default: '',
    },
    mimeTypeLabel: {
      type: String,
      default: '', // require('@/assets/images/avatars/team-thumb-1.png'),
    },

    title: {
      type: String,
      default: '',
    },

    rowBody: {
      type: String,
      default: '',
    },
    details: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};

</script>
